module.exports = __webpack_public_path__ + "media/flags/nf-b318b51b.svg";